module.exports = __webpack_public_path__ + "static/media/villainsbanner1.231778a1.png";